/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useContext } from 'react';
import ProfilePictureUploadModal from '../../../general/modal/profile-picture';
import styles from './styles.module.scss';
import { IsAdminContext } from '../../../../context';

interface UserProfilePictureDataProps {
  userProfilePictureData: string;
}

const ProfilePicture: React.FC<UserProfilePictureDataProps> = ({
  userProfilePictureData,
}: UserProfilePictureDataProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isAdmin = useContext(IsAdminContext);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const showModal = (e: any) => {
    if (isAdmin === '1') {
      setIsModalOpen(false);
    } else {
      setIsModalOpen(true);
    }
  };

  return (
    <>
      <img
        className={styles['profile-picture']}
        src={userProfilePictureData}
        style={{ cursor: 'pointer' }}
        onClick={showModal}
        onError={(e: any) => {
          e.target.src = '/no_image.png';
        }}
      />
      {userProfilePictureData && (
        <ProfilePictureUploadModal
          {...{ isModalOpen, setIsModalOpen, userProfilePictureData }}
        />
      )}
    </>
  );
};

export default ProfilePicture;
